module.exports = __webpack_public_path__ + "img/SM6_MASK_L.6174b870.png";